import { TableSkeleton } from '@/components/skeletons/table-skeleton'

import { Title } from './card'

export const AuthPendingComponent = () => {
	return (
		<>
			<Title>Loading</Title>

			<TableSkeleton rows={2} />
		</>
	)
}
